<form (ngSubmit)="onDownload()" [formGroup]="downloadForm">
  <div class="flex justify-center">
    <mat-form-field>
      <mat-label>{{ 'catalog.multi_image_download.resolution' | transloco }}</mat-label>
      <mat-select [compareWith]="compareResolutions" formControlName="resolution">
        @for (res of resolutions; track res) {
          <mat-option [value]="res">
            {{ res.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex justify-center">
    <mat-form-field>
      <mat-label>{{ 'catalog.multi_image_download.zip_name' | transloco }}</mat-label>
      <input formControlName="zip_name" matInput/>
    </mat-form-field>
  </div>

  <div class="flex justify-center">
    <button [disabled]="countChecked === 0 || !downloadForm.valid || disabled" class="primary-button"
            mat-stroked-button>
      <mat-icon>cloud_download</mat-icon>
      <span>{{ 'catalog.multi_image_download.start_download' | transloco }}</span>
    </button>
  </div>
</form>
